import React, { useState } from 'react'

import { Button } from '..'

import LocationInfoFieldset from './LocationInfoFieldset'
import OutageInfoFieldset from './OutageInfoFieldset'
import CustomerInfoFieldset from './CustomerInfoFieldset'
import { services } from '../../services'
import ConfirmationMessage from '../../containers/ConfirmationMessage'
import SubmissionError from '../../components/SubmissionError'

import { useInput } from '../../hooks'

import { mapObject, Validators } from '../../utils'
import { msalApp } from '../../utils/auth'

export const ReportingForm = ({ asset, setNestModal, onclickOpen, noCloseIcon, isErrorModalStyle, setIsErrorModalStyle }) => {
  const { address: addressValue = undefined, poleNumber: poleNumberValue = undefined } = asset

  const { value: addressVal, bind: bindAddress, reset: resetAddress } = useInput(addressValue.replace(/\s+/g, ' '))

  const { value: contactName, bind: bindContactName, reset: resetContactName } = useInput()
  const { value: phoneNumber, bind: bindPhoneNumber, reset: resetPhoneNumber } = useInput()
  const { value: emailAddress, bind: bindEmailAddress, reset: resetEmailAddress } = useInput()

  const { value: poleNumber, bind: bindPoleNumber, reset: resetPoleNumber } = useInput(poleNumberValue)
  const { value: problemType, bind: bindProblemType, reset: resetProblemType } = useInput('light_out')
  const { value: lightType, bind: bindLightType, reset: resetLightType } = useInput('street_light')
  const { value: comments, bind: bindComments, reset: resetComments } = useInput()

  const [formErrors, setFormErrors] = useState({})
  const [isConfirmModal, setIsConfirmModal] = useState(false)
  const [refNum, setRefNum] = useState('')
  const [isErrorModal, setIsErrorModal] = useState(false)

  const [, setValidationFlag] =useState(false)
  const { api } = services 

  const validators = {
    address: Validators.addressText,
    contactName: Validators.text,
    phoneNumber: Validators.phoneNumber,
    emailAddress: Validators.emailAddress,
  }

  const data = {
    addressVal,
    contactName,
    phoneNumber,
    emailAddress,
    poleNumber,
    problemType,
    lightType,
    comments,
  }

  const validateForm = (data) => {
    const errors = {}
    mapObject(data, ([key, value]) => {
      try {
        if (key in validators) {
          validators[key](value)
        }
      } catch (error) {
        errors[key] = error.message
      }
    })
    return errors
  }

  const resetForm = () => {
    resetAddress()
    resetContactName()
    resetPhoneNumber()
    resetEmailAddress()
    resetPoleNumber()
    resetProblemType()
    resetLightType()
    resetComments()

    setFormErrors({})
  }

  const handleCancel = (event) => {
    event.preventDefault()
    setNestModal(false)
    resetForm()
  }
  
  const loginRequest = {   
    scopes: ["openid"],
    extraQueryParameters: {
      region: "nyupstate",
      customer_type: "home",
      method: "EMAIL",
      target: emailAddress,
      is_popup: true,
      switch_uri: process.env.REACT_APP_IAM_SWITCH_URL,
    },
  }
  
  function onVerifyEmailClick() {
    let cityAddr = data.addressVal
    let addressSplit= cityAddr.split(',')
    let userComment = data.comments === undefined ? " " : data.comments
    let poleNum =  data.poleNumber === undefined ? " " : data.poleNumber
    msalApp.authority = process.env.REACT_APP_MSAL_OUTAGE_EMAIL_VERIFICATION_AUTHORITY
    msalApp.loginPopup(loginRequest)
      .then(function(response){
        let jwt = response.idToken.rawIdToken
        api.outageDetails(data,addressSplit,userComment,poleNum,jwt)
          .then((responseData) => {
            setRefNum(responseData.data.refNum)
            setIsConfirmModal(true)
            noCloseIcon(true)
          }, (error) => {
            noCloseIcon(true)
            setIsErrorModalStyle(true)
            setIsErrorModal(true)
          })
      }).catch(function(error){
      })
  }

  const handleSubmit = (event) => {
    console.log("founddata", data, event)
    event.preventDefault()
    setFormErrors({})
    const errors = validateForm(data)
    if (errors.length !== 0) {
      if (Object.keys(errors).length) {
        setFormErrors(errors)
        setValidationFlag(false)
        return
      } else {
        setValidationFlag(true)
        onVerifyEmailClick()
      }
    }
  }

  return (
    <>
      {
        isConfirmModal ? 
          <ConfirmationMessage
            onclickOpen={onclickOpen}
            noCloseIcon={noCloseIcon}
            refNum={refNum}
          /> 
          : isErrorModal && isErrorModalStyle
            ? <SubmissionError
              onclickOpen={onclickOpen}
              noCloseIcon={noCloseIcon}
              setIsErrorModalStyle={setIsErrorModalStyle}
            />
            :<div className="allContainer reporting-form-modal" >
              <div className="modal-title">
                <div className="modal-title-content">Street Light Details</div>

                <form onSubmit={handleSubmit} className="reporting-form">
                  <p> Please review the streetlight address field and update as necessary.</p>
                  <LocationInfoFieldset {...{ bindAddress, formErrors }} />
                  <OutageInfoFieldset {...{ bindPoleNumber, bindProblemType, bindLightType, bindComments, asset }} />

                  <CustomerInfoFieldset {...{ bindContactName, bindPhoneNumber, bindEmailAddress, formErrors }} />
                  <div className="report-outage__actions">
                    <Button buttonType="primary">Report</Button>
                    <div className="form-button">
                      <Button buttonType="primary -secondary" onClick={handleCancel}>Cancel</Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
      }
   
    </>
  )
}

export default ReportingForm
